import { render } from "./Object.vue?vue&type=template&id=3d02b418&lang=pug"
import script from "./Object.vue?vue&type=script&lang=ts"
export * from "./Object.vue?vue&type=script&lang=ts"
script.render = render

export default script